import { render, staticRenderFns } from "./CreateIncomeDialog.vue?vue&type=template&id=c6c2cb8e"
import script from "./CreateIncomeDialog.vue?vue&type=script&lang=js"
export * from "./CreateIncomeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports